import { useCallback, useState } from "react";
import JobAlertsContextualForm, { JobAlertsContextualFormProps, FormFieldValues } from "./Form";
import JobAlertsContextualSuccess from "./Success";

const JobAlertsContextual = ({
    onFormSuccess = () => {},
    ...formProps
}: JobAlertsContextualFormProps) => {
    const [step, setStep] = useState<"form"|"success">("form");

    const handleFormSuccess = useCallback((formData?: FormFieldValues) => {
        onFormSuccess(formData);
        setStep("success");
    }, [onFormSuccess]);

    return (
        <>
            {step === "form" && (
                <JobAlertsContextualForm
                    {...formProps}
                    onFormSuccess={handleFormSuccess}
                />
            )}
            {step === "success" && <JobAlertsContextualSuccess />}
        </>
    );
};

JobAlertsContextual.displayName = "JobAlertsContextual";

export { JobAlertsContextual as default };
export type { JobAlertsContextualFormProps as JobAlertsContextualProps };
